module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-right-gray-f39dd86bfd45c5a2407f1580210dedaa.svg";